import { useState } from 'react'
import { Link } from 'react-router-dom'
import CSVDownloadButton from '../ui/CSVDownloadButton'
import TransactionItem from './TransactionItem'
import styles from './TransactionItem.module.css'

const TransactionItems = ({
    exportData,
    items,
    title,
    preSelectAll = false,
    hideBalance = false,
    hideTransactionCreate = false,
    FiltersHeader = null
}) => {
    if (!items || items.length === 0) {
        return hideTransactionCreate
            ? null
            : (
                <div className="text-center spc-p-1">
                    <Link to="/add-transaction" className="button button-green">
                        Create a transaction
                    </Link>
                    <p className="spc-m-t-1" style={{fontSize: ".9rem", fontWeight: '300'}}>
                        If you've already <Link to="/transactions">added transactions</Link>, they may not occur within the date range you've selected.
                    </p>
                </div>
            )
    }

    const groupedItems = items.reduce((acc, item) => {
        const month = (item.instanceDate.getMonth() + 1).toString().padStart(2, '0')
        const year = item.instanceDate.getFullYear()
        const key = `${year}-${month}`
        if (!acc[key]) {
            acc[key] = {
                label: `${item.instanceDate.toLocaleString('default', { month: 'short' }) }<br /> ${year}`,
                title: `${item.instanceDate.toLocaleString('default', { month: 'long' }) } ${year}`,
                items: []
            }
        }
        acc[key].items.push(item)
        return acc
    }, {})
    
    const groupedItemsArray = Object.entries(groupedItems).map(([key, value]) => {
        return {
            key,
            label: value.label,
            title: value.title,
            items: value.items
        }
    }).sort((a, b) => a.key > b.key ? 1 : -1)

    return groupedItemsArray && groupedItemsArray.length && (
        <div>
            <div className={styles.itemsWrap}>
                {title && (
                    <h3 className="text-center">
                        {title}
                    </h3>
                )}

                {FiltersHeader && FiltersHeader}

                {exportData && exportData.length > 0 &&
                    <div className="text-center">
                        <CSVDownloadButton data={exportData} filename={'transactions.csv'}>
                            Download
                        </CSVDownloadButton>
                    </div>
                }

                {groupedItemsArray && groupedItemsArray.length > 0 && (
                    <Items
                        preSelectAll={preSelectAll}
                        groupedItems={groupedItemsArray}
                        hideBalance={hideBalance}
                    />
                )}
            </div>
        </div>
    )
}

export default TransactionItems

const Items = ({ groupedItems, hideBalance, preSelectAll }) => {
    const [monthFilter, setMonthFilter] = useState(
        preSelectAll
            ? null
            : groupedItems[0]?.key
                ? groupedItems[0].key
                : null
    )

    const handleMonthBtnClick = (monthKey) => {
        setMonthFilter(monthKey)
    }

    // Drag-to-scroll functionality
    const handleMouseDown = (e) => {
        const container = e.currentTarget
        const startX = e.pageX - container.offsetLeft
        const scrollLeft = container.scrollLeft

        const handleMouseMove = (e) => {
            e.preventDefault()
            const x = e.pageX - container.offsetLeft
            const walk = (x - startX) * 2 // Scroll speed multiplier
            container.scrollLeft = scrollLeft - walk
        }

        const handleMouseUp = () => {
            container.style.cursor = 'grab'
            container.style.userSelect = 'auto'
            document.removeEventListener('mousemove', handleMouseMove)
            document.removeEventListener('mouseup', handleMouseUp)
        }

        container.style.cursor = 'grabbing'
        container.style.userSelect = 'none'
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleMouseUp)
    }

    return (
        <div>
            <div 
                className={styles.monthBtnWrap}
                onMouseDown={handleMouseDown}
                style={{ cursor: 'grab' }}
            >
                <MonthButton
                    monthKey={null}
                    monthLabel="All"
                    monthFilter={monthFilter}
                    onClick={handleMonthBtnClick}
                />

                {groupedItems.map(monthGroup => 
                    <MonthButton
                        key={monthGroup.key}
                        monthKey={monthGroup.key}
                        monthLabel={monthGroup.label}
                        monthFilter={monthFilter}
                        onClick={handleMonthBtnClick}
                    />
                )}
            </div>

            {groupedItems.map(monthGroup => 
                <ItemGroup
                    key={monthGroup.key}
                    monthGroup={monthGroup}
                    monthFilter={monthFilter}
                    hideBalance={hideBalance}
                />
            )}
        </div>
    )
}

const MonthButton = ({ monthKey, monthLabel, monthFilter, onClick }) => {
    return (
        <button
            key={`monthFilterBtn-${monthKey}`}
            className={`${styles.monthBtn} ${monthFilter === monthKey ? styles.active : ''} button-unstyled`}
            onClick={() => onClick(monthKey)}
            dangerouslySetInnerHTML={{__html: monthLabel}}
        />
    )
}

const ItemGroup = ({ monthGroup, monthFilter, hideBalance }) => {
    return (
        <div key={monthGroup.key} id={monthGroup.key} style={{
            display: monthFilter && monthFilter !== monthGroup.key ? 'none' : 'block'
        }}>
            <div className={styles.monthRow}>
                {monthGroup.title}
            </div>

            {monthGroup.items.map((item, index) => 
                <TransactionItem
                    hideBalance={hideBalance}
                    item={item}
                    index={index}
                    key={`transactionItem-${index}-${item.id}-${item.instanceDate}`}
                />
            )}
        </div>
    )
}